<template>
  <div class="w-full pt-6">
    <div class="flex flex-col gap-y-3">
      <BaseButton :disabled="loading" :loading="loading" type="red-primary" @click="cancel()">
        <span class="text-base">{{ $t('modal.exit.cancel_order') }}</span>
      </BaseButton>
      <BaseButton :disabled="loading" type="white" @click="modelValue.show = false">
        {{ $t('modal.exit.continue_order') }}
      </BaseButton>
    </div>

    <div v-if="error" class="mt-6">
      <p class="!font-medium text-red-500">{{ error ? $t(error) : '&nbsp' }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {useCheckoutStore} from "~/store/checkout"

const modelValue = useAttrs().modelValue as ModalModel
modelValue.icon="info"
modelValue.title="modal.exit.cancel_order.title"
modelValue.subtitle="modal.exit.cancel_order.description"
modelValue.icon_classes="!text-red-700"
modelValue.icon_wrapper_classes="bg-red-100 text-red-700"
modelValue.dismissable=true

const checkout = useCheckoutStore()
const error = ref<string | null>(null)
const success = ref<boolean>(false)
const loading = ref<boolean>(false)

async function cancel() {

  loading.value = true
  modelValue.loading = true;

  const result = await checkout.cancelReservation()

  if (isNuxtError(result)) {
    loading.value = false
    modelValue.loading = false;
    return error.value = result.message
  }

  loading.value = false
  modelValue.loading = false;
  success.value = true
}

</script>
